<template>
  <div class="news-latter">
    <v-img
      src="./newsletter-page-image-desktop.jpg"
      cover
      v-if="$vuetify.breakpoint.mdAndUp"
    />
    <v-img
      src="./newsletter-page-image-mobile.jpg"
      cover
      v-else
    />


    <div class="news-latter__section px-3">
      <h1 class="news-latter__title">
        {{ $t('NEWSLETTER.PAGE.TITLE') }}
      </h1>
      <p class="news-latter__desc">{{ $t('NEWSLETTER.PAGE.BODY1') }}</p>
      <p class="news-latter__desc" v-html="$t('NEWSLETTER.PAGE.BODY2')"></p>
    </div>


    <div class="text-xs-center"></div>
    <v-container
      class="news-latter__form-box"
    >
      <div class="news-latter__forms">
        <div class="subscribe-form news-latter__form">
          <h1 class="news-latter__form-title">{{ $tc('COMMON.BUYER') }}</h1>
          <v-form @submit.prevent="subscribe(buyerEmail, 'buyer')">
            <v-text-field
              :error-messages="buyerFormErrors.email"
              v-model="buyerEmail"
              type="email"
              required
              :label="$t('COMMON.EMAIL')"
            />
            <tk-btn
              type="submit"
              :disabled="loading"
              color="primary"
            >{{ $t('NEWSLETTER.PAGE.BTN') }}
            </tk-btn>
          </v-form>
        </div>
        <div
          class="subscribe-form news-latter__form"
        >
          <h1 class="news-latter__form-title">{{ $tc('COMMON.ARTIST') }}</h1>
          <v-form @submit.prevent="subscribe(artistEmail, 'artist')">
            <v-text-field
              :error-messages="artistFormErrors.email"
              v-model="artistEmail"
              ref="artistEmail"
              type="email"
              required
              :label="$t('COMMON.EMAIL')"
            />
            <tk-btn
              type="submit"
              :disabled="loading"
              color="primary"
            >{{ $t('NEWSLETTER.PAGE.BTN') }}
            </tk-btn>
          </v-form>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,

      buyerEmail: null,
      artistEmail: null,

      buyerFormErrors: {},
      artistFormErrors: {}
    }
  },
  computed: {
    aspectRatio() {
      return 0.93;
    },
  },
  methods: {
    async subscribe (email, type) {
      const payload = { type: type, email: email }
      this.buyerFormErrors = this.artistFormErrors = {}

      this.loading = true
      try {
        await this.$axios.post('newsletter', payload)
        this.$app.toast(this.$t('COMMON.SUBSCRIBE_SUCCESS'), 5000)
      } catch (error) {
        if (error.status === 422 && error.data) {
          if (type === 'artist') this.artistFormErrors = error.data.errors
          if (type === 'buyer') this.buyerFormErrors = error.data.errors
        }
      }
      this.loading = false
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
@import "../../components/base/smart-grid";

.news-latter{
  margin: 0;
  padding: 0;
  background-repeat: no-repeat;

  &__title{
    margin-top: 48px * 2;
    padding-bottom: 48px;

    @include xs-block{
      font-size: 26px;
      margin-top: 36px;
      padding-bottom: 36px;
    }
  }

  &__desc{
    font-size: 18px;
    @include xs-block{
      font-size: 16px;
    }
  }

  &__form-box{
    padding: 48px * 2 16px 156px;
    max-width: 1000px - 52px;

    @include xs-block{
      padding-top: 36px;
      padding-bottom: 96px;
    }
  }

  &__form-title{
    @include xs-block{
      font-size: 26px;
    }
  }

  &__section{
    text-align: center;
    max-width: 1000px + 52px;
    margin: 0 auto;
  }

  &__forms{
    display: flex;
    flex-wrap: nowrap;


    @include xs-block{
      flex-direction: column;
    }

  }
  &__form{
    flex: 1;

    text-align: center;

    &:first-child{
      margin-right: 32px;

      @include xs-block{
        margin-right: 0;
        margin-bottom: 32px;
      }
    }
  }
}
</style>
